import { GatsbyImage } from "gatsby-plugin-image";
import styled from "styled-components";

import { AspectRatio, Box } from "@vinomofo/components";

import { StorefrontImage } from "../../types";

export interface ImageGridProps {
  images: Array<StorefrontImage>;
}

export const GridWrapper = styled(Box)`
  display: grid;
  grid-template-columns: 1fr 1fr;

  @media ${({ theme }) => theme.mq.min.tablet} {
    grid-template-columns: repeat(3, 1fr);
  }

  @media ${({ theme }) => theme.mq.min.desktop} {
    grid-template-columns: repeat(4, 1fr);
  }
`;

export const ImageGrid = ({ images }: ImageGridProps): JSX.Element => {
  return (
    <GridWrapper>
      {images.map((image, i) => (
        <AspectRatio key={i} ratio={1}>
          <GatsbyImage
            image={image}
            style={{ height: "100%", textAlign: "center" }}
            imgStyle={{
              objectFit: "cover",
              objectPosition: "bottom center",
              top: "auto",
              bottom: "0",
              width: "100%",
              height: "100%",
            }}
            alt=""
          />
        </AspectRatio>
      ))}
    </GridWrapper>
  );
};
